// InventoryMovement constants — single source of truth for movement_type enum, label, and Tag color
// see: app/models/inventory_movement.rb, enum: movement_type
import { useTranslation } from 'react-i18next'

// 與 model enum 完全一致（11 種）。後端 API 直接回傳 raw enum value，FE 表列必須對齊。
export const MOVEMENT_TYPES = [
  'inbound',
  'inbound_reversal',
  'outbound',
  'transfer',
  'stock_take',
  'clear',
  'work_order_consumption',
  'work_order_production',
  'inventory_import',
  'sales_return_inbound',
  'sto_inbound',
] as const

export type MovementType = typeof MOVEMENT_TYPES[number]

export function useMovementTypeLabel() {
  const { t } = useTranslation()
  return (type: string | undefined | null): string => {
    if (!type) return ''
    switch (type as MovementType) {
      case 'inbound':                return t('enums.inventory_history.movement_type.inbound')
      case 'inbound_reversal':       return t('enums.inventory_history.movement_type.inbound_reversal')
      case 'outbound':               return t('enums.inventory_history.movement_type.outbound')
      case 'transfer':               return t('enums.inventory_history.movement_type.transfer')
      case 'stock_take':             return t('enums.inventory_history.movement_type.stock_take')
      case 'clear':                  return t('enums.inventory_history.movement_type.clear')
      case 'work_order_consumption': return t('enums.inventory_history.movement_type.work_order_consumption')
      case 'work_order_production':  return t('enums.inventory_history.movement_type.work_order_production')
      case 'inventory_import':       return t('enums.inventory_history.movement_type.inventory_import')
      case 'sales_return_inbound':   return t('enums.inventory_history.movement_type.sales_return_inbound')
      case 'sto_inbound':            return t('enums.inventory_history.movement_type.sto_inbound')
      default:                       return type
    }
  }
}

// Tag color mapping — 入庫類用暖色/綠色系（增量），出庫消耗用紅/洋紅（減量），調撥/盤點/清除用中性色：
// - inbound / inventory_import / sales_return_inbound / sto_inbound / work_order_production：增加庫存
// - outbound / work_order_consumption / inbound_reversal：減少庫存
// - transfer / stock_take / clear：位移或調整，不直接代表增減方向
const MOVEMENT_TYPE_COLORS_STRICT = {
  inbound: 'green',
  inbound_reversal: 'volcano',
  outbound: 'red',
  transfer: 'orange',
  stock_take: 'purple',
  clear: 'default',
  work_order_consumption: 'magenta',
  work_order_production: 'geekblue',
  inventory_import: 'cyan',
  sales_return_inbound: 'gold',
  sto_inbound: 'blue',
} satisfies Record<MovementType, string>

export const MOVEMENT_TYPE_COLORS: Record<string, string> = MOVEMENT_TYPE_COLORS_STRICT
